import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronDown, faCircleChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import AppModal from '../../components/common/AppModal';
import './ContextHelp.scss';
import { helpModules } from './help/helpModules';
const NBSP = '\u00A0';

interface ContextHelpProps {
  context: string;
  title?: string;
}

const ContextHelp: React.FC<ContextHelpProps> = ({ context, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [helpContent, setHelpContent] = useState<string | null>(null);
  const [helpTitle, setHelpTitle] = useState<string | null>(null);
  const [showSystemHelp, setShowSystemHelp] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [availableModules, setAvailableModules] = useState<{ title: string, context: string }[]>([]);

  const toggleCollapsed = () => {
    setIsCollapsed(prev => !prev);
  };

  const generateSystemHelpModules = () => {
    const modules = Object.keys(helpModules).map(key => ({
      title: helpModules[key].helpTitle,
      context: key,
    }));
    setAvailableModules(modules);
  };

  const launchSystemHelp = () => {
    console.log('System Help Clicked');
    closeModal();
    setIsCollapsed(false);
    setShowSystemHelp(false);
    generateSystemHelpModules();
    openModal('app-help');
  };

  const openModal = (context: string) => {
    setIsOpen(true);
    try {
      const module = helpModules[context];
      setHelpTitle(module.helpTitle);
      setHelpContent(module.helpContent);
    } catch (error) {
      setHelpContent(`Help File (${context}) Missing: Report this Error.`);
    }
  };

  const jumpModal = (context: string) => {
    closeModal();
    setShowSystemHelp(false);
    generateSystemHelpModules();
    openModal(context);
  }


  const closeModal = () => {
    setIsOpen(false);
    setHelpContent(null);
    setShowSystemHelp(true);
  };

  return (
    <div className="context-help-icon" onClick={(e) => { e.stopPropagation(); e.preventDefault(); openModal(context); }} onMouseDown={(e) => e.stopPropagation()}>
      <FontAwesomeIcon
        icon={faCircleQuestion}
        style={{ cursor: 'pointer' }}
        title={title}
      />
      <AppModal isOpen={isOpen} onClose={closeModal} width={560} maxHeight="85vh">
        <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          <h2>
            <FontAwesomeIcon icon={faCircleQuestion} />
            {NBSP}{title}
          </h2>
          <hr />
          {showSystemHelp && (
              <div className='system-help-modules'>
            <li onClick={launchSystemHelp}>Show System Help Modules.</li>
              </div>
          )}
          {!showSystemHelp && (
            <div className='system-help-modules'>
              <div
                onClick={toggleCollapsed}
                aria-expanded={!isCollapsed}
                aria-controls="collapsible-content"
              >
                Available Help Modules: {isCollapsed ? <FontAwesomeIcon icon={faCircleChevronDown} /> : <FontAwesomeIcon icon={faCircleChevronUp} />}
              </div>
              <div id="collapsible-content"
                style={{
                  height: isCollapsed ? "0px" : "auto",
                  overflow: "hidden",
                  transition: "height 0.3s ease",
                }}
              >
                <ul>
                  {availableModules.map((module, index) => (
                    <li key={index} onClick={() => jumpModal(module.context)}>
                      {module.title}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          <div className='scrollable-help'>
            <div dangerouslySetInnerHTML={{ __html: helpContent || '' }} />
          </div>
        </div>
      </AppModal>
    </div>
  );
};

export default ContextHelp;